<div id="menu1" class="tab-pane teamAttendTable" [intouchloader2]="isLoader">
    <div class="attendCal customMonthCal">
        <!-- <a href="#" class="caldArrw"><i class="material-icons">keyboard_arrow_left</i></a><span
            class="caldText">January</span><a href="#" class="caldArrw disabledArrow"><i
                class="material-icons">keyboard_arrow_right</i></a> -->
        <span><i class="material-icons">today</i><ng-month-picker [displayFormat]="'MMMM-YY'" [showIcon]="false" [(ngModel)]="myVar" ></ng-month-picker></span>

        <ul class="leaveStatusList">
            <li><span class="colorDots dot01"></span>Approved</li>
            <li><span class="colorDots dot02"></span>Pending</li>
            <li><span class="colorDots dot03"></span>Rejected</li>
        </ul>
    </div>
    <!-- <ul class="caldBtmIcon">
        <li><a href="#" class="fullscreenToggle"><i class="material-icons">fullscreen</i></a></li>
    </ul> -->
    <div class="attendTable">
        <div class="reportpanel mCustomScrollbar" data-mcs-theme="minimal-dark">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">
                                <p>Days</p>
                            </th>
                            <th scope="col" *ngFor="let day of daysListOfMonth">
                                <p>{{day}}</p>
                            </th>

                            <th scope="col" colspan="2">

                            </th>
                        </tr>
                        <tr>
                            <th scope="col">
                                <p>Employee Name</p>
                                <div class="emFilterDiv dropdown">
                                    <a href="#" class="emFilterIcon dropdown-toggle" data-toggle="dropdown"><i class="material-icons"
                                            >group</i></a>
                                    <div class="dropdown-menu">
                                        <div class="inputSec">
                                            <a href="#" class="searchIcon"><i class="material-icons">search</i></a>
                                            <input class="inputfield" type="text" value="" placeholder="Search for users" [(ngModel)]="fieldUserSearch">
                                        </div>
                                        <ul class="membersList">
                                            <ng-container *ngIf="userList | customSearchPipe:fieldUserSearch:filteredData:searchableHeaderKeys as list">
                                                <li *ngFor="let user of list" (change)="onSelectedUserChange(user);">
                                                    <label>
                                                        <input type="checkbox" name="" [(ngModel)]="user.checked" class="checkbox" > 
                                                        <div  
                                                        class="peopleText {{user.asigneeRandomColorClass}}">{{user.shortName}}</div>
                                                        <!-- <div class="peopleText pic" *ngIf="user.picture">
                                                            <img src="{{imageUrl}}{{user.picture}}">
                                                        </div> -->
                                                        {{user.name}}
                                                    </label>
                                                </li>
                                    
                                            </ng-container>
                                        </ul>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" *ngFor="let day of daysListOfMonth; let i = index;">
                                <p>{{i+1}}</p>
                            </th>

                            <th scope="col">
                                <p>Edit</p>
                            </th>
                            <th scope="col" class="lastCheckHead" (click)="isAllCheck = !isAllCheck; checkAllClick();">
                                <p>Check All</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="teamAttendanceList.length==0  &&  !isLoader  ">
                        <tr>
                            <div class="nodataDiv" >
                                <span class="nodataimg"><img src="assets/img/nodataImg.png" alt=""></span>
                                <p>No Attendance Marked</p>
                               
                            </div>
                        </tr>
                    </tbody>
                    <tbody>
                        <cdk-virtual-scroll-viewport itemSize="8" class="example-viewport">
                            <tr *cdkVirtualFor="let emp of teamAttendanceList; let j as index;">

                                <!-- <tr *ngFor="let emp of teamAttendanceList; let j as index;"> -->
                                <td scope="col">
                                    <p>{{emp.userInfo && emp.userInfo.name ? emp.userInfo.name : ''}}</p>
                                </td>
                                <td scope="col" class="{{getAttendanceSttusColor(emp, i)}}"
                                    *ngFor="let day of daysListOfMonth; let i = index;">
                                    <p *ngIf="emp.dayWiseAttendances && emp.dayWiseAttendances[i+1]">
                                        {{getAttendnaceMark(emp.dayWiseAttendances[i+1].mark)}}
                                    </p>
                                </td>

                                <!-- <td scope="col">
                                    <a href="#" *ngIf="emp.checkBoxFlagBasedOnMark" (click)="navigateToEditAttendnace(emp)" class="editIcon01"><i
                                            class="material-icons">edit</i></a>
                                </td>
                                <td scope="col" style="min-width: 80px !important;">
                                    <p><label><input  *ngIf="emp.checkBoxFlagBasedOnMark" type="checkbox" name="checkbox{{j}}"
                                                [(ngModel)]="emp.isChecked"></label></p>
                                                
                                </td> -->
                                <td scope="col">
                                    <a href="#"  (click)="navigateToEditAttendnace(emp)" class="editIcon01"><i
                                            class="material-icons">edit</i></a>
                                </td>
                                <td scope="col" style="min-width: 80px !important;">
                                    <p><label><input   type="checkbox" name="checkbox{{j}}"
                                                [(ngModel)]="emp.isChecked"></label></p>
                                                
                                </td>
                            </tr>
                        </cdk-virtual-scroll-viewport>


                    </tbody>
                </table>
            </div>
            <!-- <button type="button" class="btn btn-default ripple blueBtn" (click)="saveAttendnaceApproval()"> -->
            <div class="attenBtn formSec ">
                <div class="selectboxSec">
                    <ng-select class="select form-control e1" [items]="statusList" bindLabel="text"
                        [virtualScroll]="true" [closeOnSelect]="true" [(ngModel)]="approveStatusObj" name="status"
                        [clearable]="false" placeholder="Select Action"
                        [ngClass]="approveStatusObj ? 'selectfocus ': ''"
                        (change)="changeApprovalStatus(approveStatusObj);">
                        <ng-template ng-label-tmp let-item="item">
                            <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>

                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>

                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <!-- </button> -->
        </div>

    </div>
</div>